import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { AuthenticationService } from './authentication.service';
import { AuthenticationInfo } from '../models/authentication-info.model';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { Permission } from '../models/permission.enum';

@Injectable()
export class PermissionService {
  private _permissions: BehaviorSubject<string[]>;
  public get permissions(): Observable<string[]> {
    return this._permissions.skipWhile(permissions => permissions === undefined);
  }
  private isConsoleAdmin: boolean;

  constructor(
    private authService: AuthenticationService,
  ) {
    this._permissions = new BehaviorSubject<string[]>(undefined);
    this.isConsoleAdmin = false;
    this.authService.authenticationInfo.subscribe((authenticationInfo: AuthenticationInfo) => {
      if (authenticationInfo.user === null) {
        this._permissions.next([]);
      } else {
        if (_.find(authenticationInfo.user.roles, { name: 'Console Admin' })) {
          this.isConsoleAdmin = true;
          this._permissions.next(null);
        } else {
          this._permissions.next(_.uniq(_.flatten(_.map(authenticationInfo.user.roles, 'permissions'))));
        }
      }
    });
  }

  public hasPermission(permission: Permission): Observable<boolean> {
    return this._permissions
        .skipWhile(permissions => permissions === undefined)
        .map((permissions: string[]) => {
          return this.isConsoleAdmin ? true : permissions.indexOf(permission) > -1;
        });
  }

  public hasPermissions(...requestedPermissions: Permission[]): Observable<boolean[]> {
    return this.permissions
        .map((permissions: string[]) => {
          if (this.isConsoleAdmin) {
            return _.times(requestedPermissions.length, _.constant(true));
          }

          let results = [];
          for (let permission of requestedPermissions) {
            results.push(permissions.indexOf(permission) > -1);
          }
          return results;
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/auth/permission.service.ts